import type { Banner } from "@scott/ui-d2c/types";
import { useState } from "react";
import { pushEvent } from "../../utils/gtm.utils";
import {
  type NavigationState,
  navigationStore,
} from "./navigation-data-layer-store";

export const useNavigationStore = () => {
  const [state, setState] = useState<NavigationState>(
    navigationStore.getState()
  );

  const setLevel = (level: 1 | 2 | 3 | 4 | 5, value: string, index: number) => {
    navigationStore.setLevel(level, value, index);
    setState(navigationStore.getState());
  };

  const pushToDataLayer = () => {
    const state = navigationStore.getState();
    pushEvent("nav_menu_click", {
      hierarchy: state,
    });
  };

  function getNavigationPath(
    navState: NavigationState,
    levelsToInclude = 5
  ): string {
    return Object.values(navState)
      .slice(0, levelsToInclude)
      .filter((level) => typeof level === "string" && level !== "") // Filter empty strings
      .join("/");
  }

  const pushToBannerDataLayer = (banner: Banner, position: number) => {
    const state = navigationStore.getState();
    pushEvent("select_promotion", {
      ecommerce: {
        items: [
          {
            promotion_id: banner.itemId,
            promotion_name: banner.bannerName,
            creative_name: `${banner.bannerHeadlineEN}/${banner.bannerSubTitleEN}`,
            creative_slot: `${getNavigationPath(state)}/${position + 1}`,
            location_id: banner.itemType,
          },
        ],
      },
    });
  };

  return {
    state,
    setLevel,
    clearAll: () => {
      navigationStore.clearAll();
      setState(navigationStore.getState());
    },
    clearFromLevel: (level: 1 | 2 | 3 | 4 | 5) => {
      navigationStore.clearFromLevel(level);
      setState(navigationStore.getState());
    },
    pushToDataLayer,
    pushToBannerDataLayer,
  };
};
